import { SvgComp, SvgImageSwap } from "../../../display-items/SVGIcon";

interface IconButtonInterface {
  onClick?: (a: any) => any;
  icon?: SvgComp;
  big?: boolean;
  css?: string;
  htmlID?: string;
  buttonClasses?: string;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
}

function IconButton({
  onClick,
  icon,
  big = false,
  css,
  htmlID,
  type,
  buttonClasses,
}: IconButtonInterface) {
  return (
    <button
      className={`iconButton ${big ? "iconButton-big" : ""}  ${buttonClasses} `}
      id={htmlID}
      onClick={onClick}
      type={type}
    >
      {icon && (
        <SvgImageSwap
          src={icon}
          className={`${big ? "icon" : ""} icon ${css}`}
        ></SvgImageSwap>
      )}
    </button>
  );
}

export default IconButton;
